/**
 * Spandex Palace custom.js
 * Includes: AI Agent Accessibility Fix (LLMO + Agentic Browsing)
 */

(function () {
  'use strict';

  // ============================================================
  // AI AGENT ACCESSIBILITY FIX
  // Fixes Agentic Browsing audit failures:
  // 1. Cart icon div using aria-expanded without role=button
  // 2. Judge.me carousel links with no discernible text
  // 3. Any other empty anchor tags on the page
  // 4. Images missing alt text
  // ============================================================

  function spA11yFix() {

    // FIX 1 — Cart icon: aria-expanded on div without a role
    document.querySelectorAll(
      '.header__cart-icon[aria-expanded], .icon-state[aria-expanded], [class*="cart"][aria-expanded]'
    ).forEach(function (el) {
      if (!el.getAttribute('role')) {
        el.setAttribute('role', 'button');
        if (!el.getAttribute('tabindex')) el.setAttribute('tabindex', '0');
      }
    });

    // FIX 2 — Judge.me carousel links: derive aria-label from product URL slug
    document.querySelectorAll(
      'a.jdgm-carousel-item__product, a.jdgm-ellipsis, a[class*="jdgm"][href*="/products/"]'
    ).forEach(function (link) {
      if (link.getAttribute('aria-label')) return;
      if ((link.textContent || '').trim()) return;
      var m = (link.getAttribute('href') || '').match(/\/products\/([^?#\/]+)/);
      var name = m
        ? m[1].replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); })
        : 'Product';
      link.setAttribute('aria-label', 'View product: ' + name);
    });

    // FIX 3 — All other empty links on the page
    document.querySelectorAll('a:not([aria-label]):not([aria-labelledby])').forEach(function (link) {
      if ((link.textContent || '').trim()) return;
      if (link.querySelector('img[alt]:not([alt=""])')) return;
      var href = link.getAttribute('href') || '';
      if (!href || href === '#') return;
      var mp = href.match(/\/products\/([^?#\/]+)/);
      var mc = href.match(/\/collections\/([^?#\/]+)/);
      if (mp) {
        link.setAttribute('aria-label', 'View product: ' + mp[1].replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); }));
      } else if (mc) {
        link.setAttribute('aria-label', 'Browse collection: ' + mc[1].replace(/-/g, ' '));
      }
    });

    // FIX 4 — Images missing alt text
    document.querySelectorAll('img:not([alt])').forEach(function (img) {
      var src = img.getAttribute('src') || '';
      var fname = src.split('/').pop().split('?')[0]
        .replace(/[-_.]/g, ' ').replace(/\.[^.]+$/, '').trim();
      img.setAttribute('alt', fname || 'Spandex Palace fabric');
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', spA11yFix);
  } else {
    spA11yFix();
  }

  // Run again after full page load (catches lazy-loaded app widgets)
  window.addEventListener('load', spA11yFix);

  // Watch for Judge.me dynamically injecting carousel content
  var _spTimer = null;
  new MutationObserver(function (mutations) {
    var hasJdgm = mutations.some(function (m) {
      return Array.from(m.addedNodes).some(function (n) {
        return n.nodeType === 1 && (
          (typeof n.className === 'string' && n.className.indexOf('jdgm') !== -1) ||
          (n.querySelector && n.querySelector('[class*="jdgm"]'))
        );
      });
    });
    if (hasJdgm) {
      clearTimeout(_spTimer);
      _spTimer = setTimeout(spA11yFix, 200);
    }
  }).observe(document.body, { childList: true, subtree: true });

})();
